var render, staticRenderFns
import script from "./type.vue?vue&type=script&lang=tsx&"
export * from "./type.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cb1cb",
  null
  
)

export default component.exports